export const fxRatesKeys = {
  all: ['fxRates'] as const,
  current: ['fxRates', 'current'] as const,
  // LR-493: COB (T-1) rates for the settlement majors, distinct from the live `current` feed.
  cob: ['fxRates', 'cob'] as const,
  cobPair: (fromCurrency: string, toCurrency: string) =>
    ['fxRates', 'cob', 'pair', fromCurrency, toCurrency] as const,
} as const;
